const ServiceData = {
    buroojtrading: {
        crum: "Burooj Trading",
        title: "Burooj Trading – Global Products, Easy Trade",
        subtitle:
            "Connecting retailers with international brands through trade solutions.",
        description:
            "At Burooj, our Trading division is built on one mission: supporting retailers across Oman and the GCC by bringing world-class products closer to them. We bridge the gap between global brands and local markets, offering retailers easy access to premium products under flexible trade terms. With expertise in sourcing, distribution, and trade support, we ensure that businesses grow stronger with reliable and cost-effective supply solutions.",
        image: "/imges/service/buroojtrading.jpeg",
        offerings: {
            title: "Our Offerings",
            sections: [
                {
                    direction: "rhs",
                    heading: "Retail Product Sourcing & Distribution",
                    content:
                        "We identify and bring in-demand global products directly to retailers. With a strong network of international partners, we make sure retailers can easily access high-quality products that fit their customers’ needs.",
                    keyFeatures: [
                        "Access to leading international brands.",
                        "End-to-end sourcing and logistics support.",
                        "Competitive pricing for sustainable growth.",
                    ],
                    image: "/imges/service/open-service-1-1.png",
                },
                {
                    direction: "lhs",
                    heading: "Retail Trade Support",
                    content:
                        "We understand the challenges retailers face when dealing with global suppliers. That’s why we simplify sourcing, negotiations, and logistics—so retailers can focus on sales and customer experience while we handle the rest.",
                    keyFeatures: [
                        "Customized sourcing for retailers.",
                        "Hassle-free import and supply management.",
                        "Tailored solutions for smooth operations.",
                    ],
                    image: "/imges/service/SME.jpg",
                },
                {
                    direction: "rhs",
                    heading: "Flexible Trade Terms (Retail Finance)",
                    content:
                        "To make international products more accessible, we provide easy trade terms and financial flexibility. Retailers benefit from supportive credit options that allow them to manage cash flow effectively while expanding their product range.",
                    keyFeatures: [
                        "Easy trade credit terms.",
                        "Improved cash flow for retailers.",
                        "Financial solutions that encourage retail growth.",
                    ],
                    image: "/imges/service/Embedded.jpg",
                },
                {
                    direction: "lhs",
                    heading: "Market Expansion for Global Brands",
                    content:
                        "For international brands entering Oman, we provide retail-focused market entry strategies. From regulatory compliance to local distribution and shelf placement, we ensure brands connect seamlessly with retailers and consumers.",
                    keyFeatures: [
                        "Retail-focused entry plans",
                        "Support with local compliance",
                        "Distribution and brand positioning in stores.",
                    ],
                    image: "/imges/service/Market.jpg",
                },
            ],
        },
        whyChooseUs: {
            title: "Why Choose Burooj Trading?",
            points: [
                {
                    title: "Expert Global<br/> Sourcing",
                    description:
                        "We bring top international brands directly to retailers.",
                    image: "/imges/service/Global.png",
                },
                {
                    title: "Seamless<br/> Logistics",
                    description:
                        "From import to store shelves, handled with ease.",
                    image: "/imges/service/Seamless.png",
                },
                {
                    title: "Tailored Trade <br>Solutions",
                    description:
                        "Easy financing to keep retail business moving.",
                    image: "/imges/service/Trade.png",
                },
                {
                    title: "Market Expansion <br>Support",
                    description:
                        "Helping retailers and brands expand across the region.",
                    image: "/imges/service/Market.png",
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Trading",
            content:
                "At Burooj Trading, we’re committed to empowering retailers with access to international brands, reliable supply chains, and easy trade terms. Whether you’re a retailer looking to expand your product offering or a brand aiming to enter the Omani market, our team is here to help you grow.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/open-service-2-1.png",
        },
    },
    buroojinvestments: {
        crum: "Burooj Investments",
        title: "Burooj Investments – Smart Capital, Strategic Growth",
        subtitle: "Investment Management through Private Equity",
        description: `At Burooj Investments, we don’t just invest—we create value. As a dynamic investment firm, we identify and capitalize on high-growth opportunities across multiple sectors, fueling economic progress and financial success. Our investment strategy is rooted in innovation, sustainability, and strategic foresight, ensuring that we generate long-term returns for our stakeholders while contributing to industry-wide transformation.
      Burooj Investments is committed to making capital work smarter by identifying high-potential opportunities and strategically allocating resources for long-term growth. With a focus on venture capital, private equity, and ethical wealth creation, we empower businesses and investors to unlock financial success. Our expertise spans multiple investment avenues, ensuring businesses receive the capital they need to scale while providing investors with solid returns`,
        image: "/imges/service/buroojinvestment.png",
        offerings: {
            title: "Investment Areas",
            sections: [
                // {
                //     direction: "rhs",
                //     heading: "Venture Capital (VCC) – Fueling Innovation and High-Growth Businesses",
                //     content:
                //         "We back visionary entrepreneurs and disruptive startups with the capital and strategic guidance they need to grow. Our venture capital investments focus on scalable businesses that demonstrate strong potential for industry transformation. By investing in forward-thinking ventures, we help create the next generation of market leaders.",
                //     keyFeatures: [
                //         "Funding for startups with high-growth potential.",
                //         "Strategic mentorship and business development support.",
                //         "Access to a network of industry experts and investors",
                //     ],
                //     image: "/imges/service/Venture.jpg",
                // },
                {
                    direction: "lhs",
                    heading: "Private Equity – Long-Term Investment for Sustainable Growth",
                    content:
                        "Burooj Investments provides long-term capital to businesses through structured funds and specialized investment teams. We partner with established companies, helping them strengthen operations, expand market presence, and drive profitability. Our approach goes beyond financial backing—we work closely with leadership teams to refine strategies and unlock new opportunities.",
                    keyFeatures: [
                        "Investment in mature businesses with strong fundamentals.",
                        "Support for operational growth and market expansion.",
                        "Hands-on collaboration to enhance business value.",
                    ],
                    image: "/imges/service/private.jpg",
                },
                {
                    direction: "rhs",
                    heading: "Asset Management – Maximizing Value, Minimizing Risk",
                    content:
                        "Investing is not just about capital—it's about making smart decisions that yield high-value returns. Our asset management services provide professional oversight, ensuring optimal allocation of resources across diverse portfolios. With a focus on sustainable growth, we manage assets responsibly to build long-term wealth for our clients.",
                    keyFeatures: [
                        "Expert financial management for diversified portfolios.",
                        "Risk assessment and mitigation strategies",
                        "Data-driven insights to optimize returns.",
                    ],
                    image: "/imges/service/Asset.jpg",
                },
                {
                    direction: "lhs",
                    heading: "Sustainable & Impact Investing – Building a Responsible Future",
                    content:
                        "We believe in investments that create more than just profits—they create positive change. Our sustainable and impact investing approach focuses on ESG-driven opportunities that generate financial returns while benefiting communities and the environment. Ethical wealth creation is at the heart of our investment philosophy.",
                    keyFeatures: [
                        "Investments aligned with environmental, social, and governance (ESG) criteria.",
                        "Opportunities that balance profitability with social responsibility.",
                        "Focus on long-term impact and sustainable business practices.",
                    ],
                    image: "/imges/service/Sustainable.jpg",
                },
            ],
        },
        whyChooseUs: {
            title: "Why Choose Burooj Investments?",
            points: [
                {
                    title: "Strategic Capital<br/> Allocation",
                    description:
                        "We invest in opportunities that drive meaningful financial growth",
                    image: "/imges/service/Strategic.png",
                },
                {
                    title: "Expert-Led Decision<br/> Making",
                    description:
                        "Our team consists of seasoned investment professionals with industry expertise",
                    image: "/imges/service/Expert-Led.png",
                },
                {
                    title: "Growth-Focused  <br>Approach",
                    description:
                        "We seek businesses with strong potential and provide the resources to fuel their success.",
                    image: "/imges/service/Growth-Focused.png",
                },
                {
                    title: "Ethical and Sustainable <br>Investments",
                    description:
                        "Our focus on ESG principles reflects our commitment to responsible investing.",
                    image: "/imges/service/Ethical.png",
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Investments",
            content:
                "Investing is more than numbers—it’s about vision, resilience, and the ability to turn opportunities into success stories. Whether you are a startup seeking capital, a business looking for strategic investment, or an investor aiming for high-value returns, Burooj Investments is your trusted partner. Let’s build the future of investment together.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/open-service-2-1.png",
        },
    },
    buroojproperties: {
        crum: "Burooj Properties",
        title: "Burooj Properties – Transforming Real Estate, Maximizing Value",
        subtitle:
            "Every property has potential—our job is to unlock it",
        description:
            "Real estate is more than just bricks and mortar—it's about creating lasting value, securing investments, and fostering thriving communities. At Burooj Properties, we bridge opportunity with expertise, ensuring investors, homeowners, and businesses experience property management that goes beyond transactions. From maximizing rental income to strategic investment advisory, we provide tailored solutions that turn real estate into a high-performing asset.",
        image: "/imges/service/buroojproperties.jpg",
        offerings: {
            title: "Our Core Services",
            sections: [
                {
                    direction: "rhs",
                    heading: "Property Management – Turning Spaces into Profitable Assets",
                    content:
                        "Managing a property is an ongoing responsibility that requires insight, diligence, and the right strategy. Our property management services focus on optimizing rental income, reducing vacancies, and maintaining asset value. Whether you own a single unit or an entire portfolio, we provide hands-on management to keep your investments performing at their best",
                    keyFeatures: [
                        "Comprehensive tenant management, from screening to retention.",
                        "Rent collection and financial reporting for full transparency.",
                        "Regular maintenance and inspections to uphold property value.",
                    ],
                    image: "/imges/service/Property.png",
                },
                {
                    direction: "lhs",
                    heading: "Facility Management – Enhancing Operations, Preserving Value",
                    content:
                        "Effective facility management ensures that residential and commercial properties run smoothly. We oversee all operational aspects, from infrastructure maintenance to safety compliance, so your property functions efficiently while maintaining its long-term worth.",
                    keyFeatures: [
                        "24/7 maintenance support to prevent costly repairs",
                        "Security, cleaning, and landscaping services for a well-maintained environment",
                        "Energy-efficient solutions to optimize costs and sustainability.",
                    ],
                    image: "/imges/service/Facility.jpg",
                },
                {
                    direction: "rhs",
                    heading: "Buy & Sell Facilitation – Connecting Investors, Landlords, and Buyers",
                    content:
                        "Buying or selling property requires expertise, negotiation skills, and market insight. Our team simplifies the process by offering end-to-end transaction support, from property evaluation to legal paperwork, ensuring smooth and successful deals.",
                    keyFeatures: [
                        "Market analysis to secure the best deals.",
                        "Buyer and seller matchmaking for seamless transactions.",
                        "Legal and financial assistance throughout the process.",
                    ],
                    image: "/imges/service/Buy.jpg",
                },
                {
                    direction: "lhs",
                    heading: "Investment Advisory – Informed Decisions, Maximum Return",
                    content:
                        "Smart real estate investments are backed by research, strategy, and market foresight. We guide investors with in-depth insights, helping them identify high-yield opportunities while minimizing risks. Whether you're entering the market or expanding your portfolio, our advisory services provide the clarity you need.",
                    keyFeatures: [
                        "Market trend analysis for data-driven decisions.",
                        "Portfolio diversification strategies for risk management.",
                        "Personalized investment plans tailored to financial goals.",
                    ],
                    image: "/imges/service/Investment.jpg",
                },
            ],
        },
        whyChooseUs: {
            title: "Why Choose Burooj Properties?",
            points: [
                {
                    title: "Expert Property<br/> Oversight",
                    description:
                        "Our team handles everything from tenant relations to facility maintenance.",
                    image: "/imges/service/Expert.png",
                },
                {
                    title: "Proactive Investment<br/> Approach",
                    description:
                        "We don’t just manage properties—we enhance their potential",
                    image: "/imges/service/Proactive.png",
                },
                {
                    title: "End-to-End Real Estate <br>Solutions",
                    description:
                        "Whether you need management, transactions, or investment advice, we provide a complete suite of services",
                    image: "/imges/service/End-to-End.png",
                },
                {
                    title: "Local Expertise, Global <br>Standards",
                    description:
                        "We combine regional market knowledge with international best practices",
                    image: "/imges/service/Local.png",
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Properties",
            content:
                "Every property has a story. Whether you're an investor, landlord, or business, we help you write a profitable chapter. Reach out today to discuss how we can add value to your real estate assets.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/Partner.jpg",
        },
    },
    buroojservices: {
        crum: "Burooj Services",
        title: "Innovating Lifestyle with IoT-Powered Smart Homes",
        subtitle:
            "Every home can be smarter, our job is to make it happen.",
        description:
            "Industrial operations demand precision, efficiency, and reliability. At Burooj Services, we go beyond conventional facility management to deliver solutions that enhance productivity, safety, and asset longevity. Whether it's maintaining critical infrastructure or implementing smart facility solutions, we ensure that industrial plants, warehouses, and factories operate at peak performance.",
        image: "/imges/service/buroojservices.jpg",
        offerings: {
            title: "Our Core Services",
            sections: [
                {
                    direction: "rhs",
                    heading: "Smart Access & Security – Keeping Homes Protected",
                    content:
                        "Our smart access and security systems provide peace of mind with advanced monitoring, intelligent locks, and connected solutions designed to safeguard your home and family.",
                    keyFeatures: [
                        "Smart locks and digital access control.",
                        "Real-time video surveillance and alerts.",
                        "Advanced intrusion detection systems.",
                    ],
                    image: "/imges/service/Industrial.jpg",
                },
                {
                    direction: "lhs",
                    heading: "Safety & Automation – Smarter Everyday Living",
                    content:
                        "We integrate safety and automation into daily life, ensuring that homes are not just protected, but also efficient and convenient.",
                    keyFeatures: [
                        "Smoke, gas, and fire detection sensors.",
                        "Energy-efficient automation for lighting and appliances.",
                        "Remote control and monitoring through mobile apps.",
                    ],
                    image: "/imges/service/Infrastructure1.jpg",
                },
                {
                    direction: "rhs",
                    heading: "Safety & Compliance Services – Meeting the Highest Industry Standards",
                    content:
                        "Industrial environments demand rigorous safety and compliance measures. Our team ensures that facilities adhere to industry regulations, creating a secure and efficient workplace.",
                    keyFeatures: [
                        "Workplace safety audits and hazard assessments.",
                        "Implementation of regulatory compliance measures.",
                        "Employee training programs to reinforce safety culture.",
                    ],
                    image: "/imges/service/Safety.jpg",
                },
                {
                    direction: "lhs",
                    heading: "Smart Facility Solutions – Integrating Technology for Smarter Management",
                    content:
                        "Technology is reshaping facility management. Our smart solutions leverage automation, data analytics, and IoT for real-time monitoring and predictive maintenance, improving efficiency and reducing operatioal costs.",
                    keyFeatures: [
                        "AI-driven predictive maintenance to prevent system failures.",
                        "IoT-enabled monitoring for real-time asset performance tracking",
                        "Energy management solutions to enhance sustainability",
                    ],
                    image: "/imges/service/Smart.png",
                },
            ],
        },
        whyChooseUs: {
            title: "Why Choose Burooj Services?",
            points: [
                {
                    title: "Industry<br> Expertise",
                    description:
                        "Decades of experience in managing industrial facilities",
                    image: "/imges/service/Industry.png",
                },
                {
                    title: "Proactive<br> Maintenance",
                    description:
                        "Reducing downtime and optimizing operational efficiency.",
                    image: "/imges/service/ProactiveMaintenance.png",
                },
                {
                    title: "Regulatory<br> Compliance",
                    description:
                        "Ensuring adherence to local and international safety standards.",
                    image: "/imges/service/Regulatory.png",
                },
                {
                    title: "Technology-Driven <br>Solutions",
                    description:
                        "Integrating automation for smarter facility management.",
                    image: "/imges/service/Technology.png",
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Services",
            content:
                "Smart living is the future, and Burooj is here to deliver it. Whether you’re building a new home or upgrading an existing one, we provide innovative IoT-based solutions that ensure safety, comfort, and style.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/Partnerservice.jpg",
        },
    }
};
export default ServiceData;